(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["details-produits"]) return;
  try {
    
  var miniatures = document.querySelectorAll('.details-produits .all-details .miniature img');
  for (var i = 0; i < miniatures.length; i++) {
    miniatures[i].addEventListener('click', function(event) {
      var img = event.target;
      var number = img.parentElement.getAttribute("number");
      img.parentElement.parentElement.parentElement.querySelector('.section-details[number="'+ number +'"]').classList.add("active");
      document.head.insertAdjacentHTML('beforeend', '<style id="style-pop-up">#fullpage{z-index: 11000;}</style>');
    });
  }

  var croix = document.querySelectorAll('.details-produits .fp-overflow .all-details .section-details>div figcaption .croix-pop-up');
  for (var i = 0; i < croix.length; i++) {
    croix[i].addEventListener('click', function(event) {
      this.parentElement.parentElement.parentElement.classList.remove("active");
      document.querySelector('#style-pop-up').remove();
    });
  }

  window.addEventListener("load", (event) => {
    var mainElement = document.querySelector('main#fullpage');
    var activeSection = mainElement.querySelector('.section.details-produits.produits-associes');
    var position = Array.from(mainElement.children).indexOf(activeSection);
    document.head.insertAdjacentHTML('beforeend', '<style>.details-produits .fp-overflow .all-details .section-details{top: '+ (position - 1) +'00vh;}</style>');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["histoire"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", (event) => {
    var heightFig = document.querySelector(".petite-histoire>div figcaption").offsetHeight;
    document.querySelector(".petite-histoire>div figure").style.cssText = "height: calc(100vh - "+ (heightFig + 170) +"px);";
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["images-produits"]) return;
  try {
    
  var splide = new Splide( '.section.images-produits.splide', {
      breakpoints: {
        900: {
          type: 'loop',
          autoplay: true,
          autoWidth:true,
          interval: 5000,
          pauseOnHover: false,
          focus: 'center',
          speed: 1000,
          perPage: 1,
          direction: 'ltr',
          focus: 'left',
          gap: '0px',
          pagination: false,
          easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
          drag: false,
          arrowPath: 'M5.7663 12.2838L0 0.989739L0.687803 0L7 12.3633L0.664178 23L0.0236208 21.9246L5.7663 12.2838Z',
          },
      },
      }
   );
  splide.mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-a-propos"] && !Shopify.designMode) return;
  try {
    
if (!!document.querySelector(".section-details.splide") === true){
  var splide = new Splide( '.section-details.splide', {
      type: 'loop',
      autoplay: false,
      autoWidth:true,
      interval: 5000,
      pauseOnHover: false,
      focus: 'center',
      speed: 1000,
      perPage: 1,
      direction: 'ltr',
      focus: 'center',
      gap: '0px',
      pagination: true,
      arrows: true,
      easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
      drag: false,
      arrowPath: 'M5.7663 12.2838L0 0.989739L0.687803 0L7 12.3633L0.664178 23L0.0236208 21.9246L5.7663 12.2838Z',
      }
   );
  splide.mount();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.querySelectorAll('.section.collection-grid .fp-overflow .collection-products li').forEach(function(li) {
    var splideInstance = new Splide(li.querySelector('.splide'), {
        type: 'loop',
        autoplay: false,
        autoWidth: true,
        pauseOnHover: false,
        focus: 'center',
        speed: 1000,
        perPage: 1,
        direction: 'ltr',
        gap: '0px',
        pagination: false,
        easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
        drag: false,
        arrowPath: 'M5.7663 12.2838L0 0.989739L0.687803 0L7 12.3633L0.664178 23L0.0236208 21.9246L5.7663 12.2838Z'
    });
    splideInstance.mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.querySelectorAll('.collection-products li.li-product').forEach(function(li) {
    var splideInstance = new Splide(li.querySelector('.splide'), {
        type: 'loop',
        autoplay: false,
        autoWidth: true,
        pauseOnHover: false,
        focus: 'center',
        speed: 1000,
        perPage: 1,
        direction: 'ltr',
        gap: '0px',
        pagination: false,
        easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
        drag: false,
        arrowPath: 'M5.7663 12.2838L0 0.989739L0.687803 0L7 12.3633L0.664178 23L0.0236208 21.9246L5.7663 12.2838Z'
    });
    splideInstance.mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
  var splide = new Splide( '.slider.splide', {
      type: 'loop',
      autoplay: true,
      autoWidth:true,
      interval: 6000,
      pauseOnHover: false,
      focus: 'center',
      speed: 1000,
      perPage: 1,
      direction: 'ltr',
      focus: 'center',
      gap: '0px',
      pagination: true,
      easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
      drag: false,
      arrowPath: 'M5.7663 12.2838L0 0.989739L0.687803 0L7 12.3633L0.664178 23L0.0236208 21.9246L5.7663 12.2838Z',
      }
   );
  splide.mount();

  } catch(e) { console.error(e); }
})();
})();
